<template>
  <div class="view-dialog">
    <!-- Username -->
    <div class="detail-group">
      <label>Username:</label>
      <span>{{ userName }}</span>
    </div>

    <!-- Email -->
    <div class="detail-group">
      <label>Email:</label>
      <span>{{ email }}</span>
    </div>

    <!-- Role -->
    <div class="detail-group">
      <label>Role:</label>
      <span>{{ userType }}</span>
    </div>

    <!-- Nickname -->
    <div class="detail-group">
      <label>Nickname:</label>
      <span>{{ nickName }}</span>
    </div>

    <!-- Bio -->
    <div class="detail-group">
      <label>Bio:</label>
      <span>{{ bio }}</span>
    </div>

    <!-- Gender -->
    <div class="detail-group">
      <label>Gender:</label>
      <span>{{ gender }}</span>
    </div>

    <div class="detail-group">
      <label>{{ userType === 'developer' ? 'Projects Owned:' : 'Projects Joined:' }}</label>
      <span v-if="!games.length">None</span>
      <span v-else>{{ games.map(g => g.gameName).join(', ') }}</span>
    </div>

    <div class="detail-group">
      <label>Playtesters Enrolled:</label>
      <span>{{ totalPlaytesters }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userName: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    userType: {  // Corrected prop name
      type: String,
      default: '' 
    },
    nickName: {
      type: String,
      default: ''
    },
    bio: {
      type: String,
      default: ''
    },
    gender: {
      type: String,
      default: "Gender not specified"
    },
    games: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    totalPlaytesters() {
      return this.games.reduce((sum, g) => sum + (g.testerCount || 0), 0);
    }
  }
}
</script>


<style scoped>
.view-dialog {
  padding: 20px;
  max-width: 900px; /* Same as edit dialog width */
  width: 100%;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.detail-group {
  margin-bottom: 15px;
}

.detail-group label {
  color: #f97427;
  font-weight: bold;
  margin-right: 10px;
}

.detail-group span {
  color: black;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/admin-only/ViewUserDialog.vue